import { useState } from "react";
import { AccordionSection } from "../Accordion";
import "./GoodFillFooter.scss";

export const ImportantNoteAccordion = () => {
  const [isImportantNoteAccordionOpen, setImportantNoteAccordionOpen] = useState(false);

  return (
    <AccordionSection
      title={"Important Notes"}
      isOpen={isImportantNoteAccordionOpen}
      setIsOpen={setImportantNoteAccordionOpen}
      className="GoodFillFooter_accordion"
    >
      <p className="text-white text-xs">
        All investing involves risk.
        <br />
        Brokerage services are offered through Goodfill USA, LLC (“GUSA”) a registered broker dealer (member SIPC) and
        clearing services through Interactive Brokers, LLC, (“IB LLC”) a registered broker dealer (member SIPC).
        Securities products offered by GUSA are not FDIC insured and involve risk, including possible loss of
        principal. Keep in mind that trading commissions and, in certain cases, ACH, wire transfer fees and paper
        statement fees may apply to your brokerage account. Please see GUSA&apos;s Fee Schedule to learn more.
      </p>
    </AccordionSection>
  );
};
